import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown, Avatar, Modal, Input, Form, notification } from 'antd'
import { Link } from 'react-router-dom';
import styles from './style.module.scss'
import CommonService from '../../../../services/commonService'
import dataConstant from '../../../../constants/dataConstants'
import messageConstant from '../../../../constants/messageConstant'
import urlConstant from '../../../../constants/urlConstant'
import SwitchAccount from './switchAccount/index'

@connect(({ user }) => ({ user }))
@Form.create()
class ProfileMenu extends React.Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
  }

  state = {
    count: 7,
    visibeChangePasswordPopup: false,
    visibeSwitchAccountPopup: false,
    changePasswordModel: {
      OldPassword: '',
      NewPassword: '',
      ConfirmPassword: '',
      UserId: ''
    }
  }

  onSubmitChangePassword() {
    const { form } = this.props
    form.validateFields((error, values) => {
      if (!error) {
        const userData = JSON.parse(localStorage.getItem('webappuser'))
        values.UserId = userData.userid
        this.setCustomSpinner()
        this.CommonService.httpPost(urlConstant.Account.ChangePassword, values, true)
          .then(response => {
            if (response.Status === 'Success') {
              this.removeCustomSpinner()
              notification.success({
                message: dataConstant.ChangePassword,
                description: response.description,
              })
              this.resetForm()
            } else if (response.Status === 'Failure') {
              this.removeCustomSpinner()
              console.log(response)
              notification.warning({
                message: dataConstant.ChangePassword,
                description: messageConstant.OldPasswordIncorrect,
              })
            }
          })
          .catch(err => {
            this.removeCustomSpinner()
            console.log(err)
          })
      }
    })
  }

  setCustomSpinner = () => {
    const { dispatch } = this.props
    dispatch({
      type: dataConstant.CustomSpinner.Setloader,
    })
  }

  removeCustomSpinner = () => {
    const { dispatch } = this.props
    dispatch({
      type: dataConstant.CustomSpinner.RemoveLoader,
    })
  }

  checkPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && value !== form.getFieldValue('NewPassword')) {
      callback(messageConstant.NewPasswordNotMatch)
    } else {
      callback()
    }
  }

  ChangePasswordOpenPopup = () => {
    this.setState({ visibeChangePasswordPopup: true })
  }

  SwitchAccountOpenPopup = () => {
    this.setState({ visibeSwitchAccountPopup: true })
  }

  handleOkChangePassword = e => {
    console.log(e)
    this.onSubmitChangePassword()
  }

  resetForm = () => {
    const { form } = this.props
    this.setState({
      changePasswordModel: {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: '',
        UserId: ''
      },
      visibeChangePasswordPopup: false
    })
    form.resetFields()
  }


  handleCancelChangePassword = () => {
    this.resetForm()
  }

  logout = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  addCount = () => {
    let { count } = this.state
    count += 1
    this.setState({
      count,
    })
  }

  switchAccountVisibilityChange = (isVisible) => {
    this.setState({ visibeSwitchAccountPopup: isVisible })
  }

  userImpersonateLogout = () => {
    const { user: { TenantGuid } } = this.props
    const userData = JSON.parse(localStorage.getItem('webappuser'))
    localStorage.clear()
    window.location.href = `${urlConstant.Impersonate.UserImpersonateLogout}?q=${TenantGuid}&impersonatingUserId=${userData.ImpersonateUserID}&ImpersonatorClientId=${userData.ImpersonatorClientId}`
  }

  render() {
    const { user, form } = this.props
    const userData = JSON.parse(localStorage.getItem('webappuser'))
    // const { count } = this.state
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <strong>
            Hello, {user.name || 'Anonymous'}
          </strong>
          <div>
            <strong>
             Role:{' '}
            </strong>
            {user.role}
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <div>
            <strong>
              Email:{' '}
            </strong>
            {user.email}
            <br />
            <strong>
              Phone:{' '}
            </strong>
            {user.Phone || '-'}
          </div>
        </Menu.Item>
        {/* <Menu.Item>
          <a href="javascript: void(0);">
            <i className={`${styles.menuIcon} icmn-user`} />
            Edit Profile
          </a>
        </Menu.Item> */}
        {/* <Menu.Divider /> */}
        { user && user.role && (user.role === dataConstant.RoleType.Supplier || user.role === dataConstant.RoleType.FactoryAdmin || user.role === dataConstant.RoleType.FactoryStaff || user.role === dataConstant.RoleType.Wholesaler) &&
          <Menu.Divider />
        }
        { user && user.role && (user.role === dataConstant.RoleType.Supplier || user.role === dataConstant.RoleType.FactoryAdmin || user.role === dataConstant.RoleType.FactoryStaff || user.role === dataConstant.RoleType.Wholesaler) &&
          <Menu.Item>
            <Link to="/apicredentials">
              <i className={`${styles.menuIcon} fa fa-key`} />
              API Credentials
            </Link>
          </Menu.Item>
        } 
        {userData && userData.IsImpersonate !== 'true' &&
          <Menu.Divider />
        }            
        {userData && userData.IsImpersonate !== 'true' &&
          <Menu.Item>
            <a href="javascript: void(0);" onClick={this.SwitchAccountOpenPopup}>
              <i className={`${styles.menuIcon} fa fa-exchange`} />
               Switch Account
            </a>
          </Menu.Item>
        }            
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);" onClick={this.ChangePasswordOpenPopup}>
            <i className={`${styles.menuIcon} fa fa-lock`} />
            Change Password
          </a>
        </Menu.Item>
        {user.role === dataConstant.RoleType.Admin &&
          <Menu.Divider />
        }
        {user.role === dataConstant.RoleType.Admin &&
          <Menu.Item>
            <Link to="/companyprofile">
              <i className={`${styles.menuIcon} fa fa-suitcase`} />
              Company Profile
            </Link>
          </Menu.Item>
        }        
        <Menu.Divider />
        <Menu.Item>
          <Link to="/profile">
            <i className={`${styles.menuIcon} fa fa-user`} />
            User Profile
          </Link>
        </Menu.Item>
        { userData && !userData.IsImpersonate &&
          <Menu.Divider />
        }
        { userData && !userData.IsImpersonate &&
          <Menu.Item>
            <a href="javascript: void(0);" onClick={this.logout}>
              <i className={`${styles.menuIcon} icmn-exit`} />
              Logout
            </a>
          </Menu.Item>
        }
        { userData && userData.IsImpersonate &&
          <Menu.Item>
            <a href="javascript: void(0);" onClick={this.userImpersonateLogout}>
              <i className={`${styles.menuIcon} icmn-exit`} />
              Logout from Impersonate
            </a>
          </Menu.Item>
        }

      </Menu>
    )
    const { getFieldDecorator } = form;
    const { visibeChangePasswordPopup, changePasswordModel, visibeSwitchAccountPopup } = this.state
    const { OldPassword, NewPassword, ConfirmPassword } = changePasswordModel

    return (
      <div>
        <Dropdown overlay={menu} trigger={['click']} onVisibleChange={this.addCount}>
          <div className={styles.dropdown}>
            {/* <Badge count={count}> */}
            <Avatar className={styles.avatar} shape="square" size="large" icon="user" />
            {/* </Badge> */}
          </div>
        </Dropdown>
        <Modal
          title={dataConstant.ChangePassword}
          visible={visibeChangePasswordPopup}
          okText={dataConstant.ChangePassword}
          onOk={this.handleOkChangePassword}
          onCancel={this.handleCancelChangePassword}
          maskClosable={false}
          width="500px"
        //  bodyStyle={{height:250}}
        >
          <Form onSubmit={this.onSubmitChangePassword}>
            <div className="row">
              <div className="col-xl-12">
                <Form.Item label="Old Password">
                  {getFieldDecorator('OldPassword', {
                    initialValue: OldPassword,
                    rules: [
                      { required: true, message: `${messageConstant.Required} old password` },
                      {
                        pattern: new RegExp(dataConstant.PasswordRegexp),
                        message: messageConstant.PasswordRequires
                      }
                    ],
                  })(<Input size="default" type="password" />
                  )}
                </Form.Item>
                <Form.Item label="New Password">
                  {getFieldDecorator('NewPassword', {
                    initialValue: NewPassword,
                    rules: [
                      { required: true, message: `${messageConstant.Required} new password` },
                      {
                        pattern: new RegExp(dataConstant.PasswordRegexp),
                        message: messageConstant.PasswordRequires
                      }
                    ],
                  })(<Input size="default" type="password" />
                  )}
                </Form.Item>
                <Form.Item label="Confirm Password">
                  {getFieldDecorator('ConfirmPassword', {
                    initialValue: ConfirmPassword,
                    rules: [{ required: true, message: `${messageConstant.Required} confirm password` },
                    {
                      validator: this.checkPassword,
                    },
                    ]
                  })(<Input size="default" type="password" />
                  )}
                </Form.Item>
              </div>
            </div>
          </Form>
        </Modal>
        <SwitchAccount visible={visibeSwitchAccountPopup} switchAccountVisibilityChange={(isVisible) => this.switchAccountVisibilityChange(isVisible)} />
      </div>
    )
  }
}

export default ProfileMenu
